// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__xEc8n","infoBtn":"quickbooks_infoBtn__1hZj_","formBox":"quickbooks_formBox__2mydE","formFooter":"quickbooks_formFooter__3KkEu"};